import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { formatDirectUrl, getUrlTarget } from 'helpers/ContentHelper';
import Style from './HomeSlidePromo.module.scss';

/**
 * HomeSlidePromo Component
 * @param {Object}   panel        - Panel object
 * @returns {Component}           - React Component
    <HomeSlidePromo item={item} />
 */
const HomeSlidePromo = (props = {}) => {
  const {
    id,
    headline,
    headlineInside,
    altHeadline,
    description,
    subDescription,
    network,
    networkLogoUrl,
    url,
    buttonText,
  } = props;
  const uId = _.uniqueId(id);
  const formattedUrl = formatDirectUrl(url);
  const { target, rel } = getUrlTarget(formattedUrl);
  const button =
    buttonText && formattedUrl ? (
      <Link to={formattedUrl} target={target} rel={rel} className={Style.showButton}>
        {buttonText}
      </Link>
    ) : null;
  const headlineComp = headline && <h2 className={Style.headline}>{headline}</h2>;
  const descriptionComp = description && (
    <div className={Style.description}>
      {description}
      <img className={Style.networkLogo} src={networkLogoUrl} alt={network} />
    </div>
  );
  return (
    <div className={Style.container} id={`${uId}_slide`}>
      <div className={Style.header}>
        {!headlineInside && headlineComp}
        <div className={Style.infoContainer}>
          <div className={Style.altHeadline}>{altHeadline}</div>
          {headlineInside && headlineComp}
          {descriptionComp}
          <div className={Style.meta}>{subDescription}</div>
          <div className={Style.buttons}>{button}</div>
        </div>
      </div>
    </div>
  );
};

HomeSlidePromo.defaultProps = {
  headlineInside: false,
  description: null,
  subDescription: null,
  network: null,
  networkLogoUrl: null,
};

HomeSlidePromo.propTypes = {
  id: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  altHeadline: PropTypes.string.isRequired,
  description: PropTypes.string,
  subDescription: PropTypes.string,
  network: PropTypes.string,
  networkLogoUrl: PropTypes.string,
  url: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  headlineInside: PropTypes.bool,
};

export default HomeSlidePromo;
